module.exports = __webpack_public_path__ + "static/media/chatkit.5501a398.png";